import React from 'react';

const NoParamMessage = (): JSX.Element => (
    <div className="text-center my-6 text-silver">
        <p className="font-weight-600">No Timesheet Record Found</p>
        <p>To approve a timesheet, please click on the link emailed from your client manager at Medical Solutions.</p>
        <p>Thank you!</p>
    </div>
);

export default NoParamMessage;
